module.exports = __webpack_public_path__ + "static/media/Lonely Struggle - Introduction - English translation by JL.a1a4208d.txt";